var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecognizeSomeone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 51,
    viewBox: "0 0 71 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24193 4.13747C-8.66108 16.3042 5.29303 33.1244 14.258 40.0136C26.8362 49.6796 55.9232 58.9312 68.0165 40.0136C81.4478 19.0032 27.1207 -11.0709 7.24193 4.13747Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 40.0342C18.441 39.3368 25.4154 34.4547 27.8564 26.7829C28.5538 22.2496 27.0557 18.0625 24.7179 14.9265",
    stroke: "#83A9FF",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1128 24.3419C26.8103 19.8086 24.2659 18.0625 21.9282 14.9265",
    stroke: "#83A9FF",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6459 25.4167C31.5665 21.8802 27.9097 19.8635 27.5078 15.9728",
    stroke: "#83A9FF",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0666 25.0396C25.764 21.2037 24.0205 19.8088 21.2307 17.3678",
    stroke: "#83A9FF",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8565 26.7841C27.5078 26.7841 24.3693 25.3892 22.6257 25.3892",
    stroke: "#83A9FF",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9215 44.2656C47.6262 43.1809 41.5374 37.2308 40.375 29.2644C40.4231 24.678 42.5815 20.7899 45.3976 18.0753",
    stroke: "#F1BD6C",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.492 27.1394C42.5402 22.553 45.3343 21.2433 48.1504 18.5287",
    stroke: "#F1BD6C",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8179 27.788C37.5105 23.824 41.4463 22.4281 42.4749 18.6543",
    stroke: "#F1BD6C",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.411 27.9983C43.3459 24.1001 45.2929 23.0069 48.4421 21.0515",
    stroke: "#F1BD6C",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3748 29.2647C40.7189 29.3214 44.0423 28.4548 45.7627 28.738",
    stroke: "#F1BD6C",
    strokeWidth: 2.38083,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6617 10.5153L29.0945 7.78564",
    stroke: "#83A9FF",
    strokeWidth: 1.19041,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7842 12.5902L45.3462 10.7617",
    stroke: "#F1BD6C",
    strokeWidth: 1.19041,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0465 9.14637L35.1338 6",
    stroke: "#83A9FF",
    strokeWidth: 1.19041,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8085 9.75264L41.6367 7.19043",
    stroke: "#F1BD6C",
    strokeWidth: 1.19041,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognizeSomeone);
export default __webpack_public_path__ + "static/media/recognize-someone.225e457c990c129be6ad01cacaf46361.svg";
export { ForwardRef as ReactComponent };